'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { AnimatePresence, motion, type Variants } from 'motion/react';
import { useState } from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { Icon } from '~/components/primitives';
import type { SB_FooterMenuGroupProps } from '~/storyblok/components/types.generated';
import { StoryblokLink } from '~/storyblok/utils/StoryblokLink';
const FooterAccordion: React.FC<{
  className?: string;
  items: SB_FooterMenuGroupProps[];
}> = props => {
  const $ = _c(14);
  const [activeItem, setActiveItem] = useState(null);
  const getValue = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      closed: {
        opacity: 0,
        height: 0
      },
      open: {
        opacity: 1,
        height: "auto"
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const VARIANTS = t0;
  let t1;
  if ($[1] !== props.className) {
    t1 = cx("border-b border-blue-700", props.className);
    $[1] = props.className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = value => setActiveItem(value);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeItem || $[5] !== props.items) {
    let t4;
    if ($[7] !== activeItem) {
      t4 = (group, i) => {
        const isOpen = activeItem === getValue(i);
        return <AccordionPrimitive.Item key={getValue(i)} value={getValue(i)} className="border-t border-blue-700 px-6 pb-2"><AccordionPrimitive.Trigger className="flex w-full flex-row pb-8 pt-10 text-left"><h3 className="flex-1 font-bold">{group.title}</h3><motion.div animate={{
              rotate: isOpen ? 180 : 0
            }}><Icon name="chevron-down" className="stroke-turqoise-500" /></motion.div></AccordionPrimitive.Trigger><AnimatePresence>{isOpen && <AccordionPrimitive.Content forceMount={true} asChild={true}><motion.div variants={VARIANTS} exit="closed" initial="closed" animate="open" className="overflow-hidden"><ul className="flex flex-col gap-6 pb-10 leading-none md:gap-5">{group.menuItems?.map(_temp2)}</ul></motion.div></AccordionPrimitive.Content>}</AnimatePresence></AccordionPrimitive.Item>;
      };
      $[7] = activeItem;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = props.items.map(t4);
    $[4] = activeItem;
    $[5] = props.items;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <AccordionPrimitive.Root type="single" defaultValue="item-1" collapsible={true} onValueChange={t2}>{t3}</AccordionPrimitive.Root>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t4) {
    t5 = <div className={t1}>{t4}</div>;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default FooterAccordion;
function _temp(v) {
  return `item-${v}`;
}
function _temp2(item) {
  return <li key={item.text} className="text-blue-300">{!!item.link ? <StoryblokLink type="link" link={item.link}>{item.text}</StoryblokLink> : item.text}</li>;
}